import when from "mobx";
import DataStore from "./stores/DataStore";
/**
 * @class
 * Klasse, die für das Senden/Speichern der Änderungen regelt.
 */
class SaveChangesHandler {
  /**
   * @constructor
   * @param {DataHandler} dataHandler Um die Daten aus den AttributEdit "herauszuholen"
   * @param {RequestHandler} requestHandler Um die Daten an einen Server zu schicken
   * @param {MessageHandler} messageHandler Um allgemeine Nachrichten anzuzeigen und fürs Debuggen
   */
  constructor(dataHandler, requestHandler, messageHandler, key) {
    this.dataHandler = dataHandler;
    this.requestHandler = requestHandler;
    this.messageHandler = messageHandler;
    this.key = key;
    DataStore.setHandler({
      saveChangesHandler: this,
    });
  }

  /**
   * Prüft Daten auf Fehler (Rules), gibt die Daten zurück (bei success) oder einen Log an Fehlern
   * @param {Function} dataSuccessFun Funktion, welche aufgerufen wird, wenn die Daten nicht fehlerhaft sind
   * @param {Function} dataErrrorFun  Funktion, welche aufgerufen wird, wenn die Daten  fehlerhaft sind
   */
  saveChanges(dataSuccessFun, dataErrrorFun) {
    this.dataHandler.getAllDataChecked(
      (data) => this.handleDataSuccess(data, dataSuccessFun),
      (errLog) => this.handleDataError(errLog, dataErrrorFun)
    );
  }

  handleDataError(errLog, callback = () => {}) {
    this.messageHandler.logDebugFormatted(
      "SaveChangesHandler",
      "handleDataError",
      "",
      "",
      "",
      errLog
    );
    callback(errLog);
  }

  handleDataSuccess(data, callback = () => {}) {
    this.messageHandler.logDebugFormatted(
      "SaveChangesHandler",
      "handleDataSuccess",
      data
    );
    data.geometryChanges = DataStore.geometryChanges;
    this.sendData(data);
    callback(data);
  }

  sendData(data) {
    // fürs testen....
    DataStore.requestStore.requests[this.key].setValue(
      this.dataHandler.transformOut(data)
    );
    DataStore.requestStore.requests[this.key].setState("toRequest");
    // const {editToolbarSettings={}} = DataStore
    // const {saveEditToolbarChanges=()=>{}} = editToolbarSettings
    // saveEditToolbarChanges(); 
    // setTimeout(
    //   function() {
    //       // this.summaryModul.setSuccess();
    //     DataStore.requestStore.requests[this.key].setState(1)
    //       setTimeout(
    //         function() {
    //             DataStore.requestStore.requests[this.key].setState(2)
    //             DataStore.requestStore.requests[this.key].setMessage("Fehler") //Diese Sachne hier müssten eigentlich von einem RequestHandler beearbeitet werden...
    //             // this.summaryModul.setError('Fehler');
    //             setTimeout(3000);
    //         }.bind(this),
    //         3000,
    //       );
    //   }.bind(this),
    //   3000,
    // );
  }

  setSummaryModul(modul) {
    this.summaryModul = modul;
  }
}

export default SaveChangesHandler;
